import React, { Suspense } from 'react';
import { withPageReadyAsync } from '@bingads-webui-react/with-page-ready';

const DelayedInlineSupport = withPageReadyAsync(() =>
  import(/* webpackMode: 'lazy' */ /* webpackChunkName: "inline-support.async" */'./inline-support-with-i18n').then(({ InlineSupportWithI18n }) => ({
    default: InlineSupportWithI18n,
  })));

export const InlineSupport = () => (
  <Suspense fallback={<div />}>
    <DelayedInlineSupport />
  </Suspense>
);
